import { render, staticRenderFns } from "./MyRecurringSubscriptionList.vue?vue&type=template&id=3684d453&"
import script from "./MyRecurringSubscriptionList.vue?vue&type=script&lang=js&"
export * from "./MyRecurringSubscriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports